module.exports = __webpack_public_path__ + "img/logo_f(x)bridge.baef25dd.png";